import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";

export const useAccessoriesImages = (accessories) => {
  const [imagesMap, setImagesMap] = useState({});

  useEffect(() => {
    const loadImages = async () => {
      if (!accessories || accessories.length === 0) {
        return;
      }

      const imagePromises = accessories.map(async (accessory) => {
        if (!accessory.pimId) {
          return { pimId: null, image: null };
        }

        const obj = await Scrivito.load(() =>
          Scrivito.Obj.where("pimId", "equals", accessory.pimId).first(),
        );
        return { pimId: accessory.pimId, image: obj };
      });

      const results = await Promise.all(imagePromises);

      const newImagesMap = {};
      results.forEach(({ pimId, image }) => {
        if (pimId) {
          newImagesMap[pimId] = image;
        }
      });

      setImagesMap(newImagesMap);
    };

    loadImages();
  }, [accessories]);

  return { imagesMap };
};
